import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import en from '../lang/en.json'
import es from '../lang/es.json'
import de from '../lang/de.json'
import ar from '../lang/ar.json'
import jp from '../lang/jp.json'
import getCookie from '@/assets/javascripts/get_cookie'

Vue.use(VueI18n)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: '',
  messages: { en, es, de, ar, jp }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#uyh-app')

router.afterEach(to => {
  if (to.params.resource != undefined) {
    document.cookie = `template=${to.params.resource}`
  }
  if (to.params.mantraId != undefined) {
    document.cookie = `mantraid=${to.params.mantraId}`
  }
  window.dataLayer.push({
    'event': 'virtual-pageview',
    'virtualPath': to.path,
    'virtualTitle': to.meta.title,
    'virtualSection': to.meta.section,
    'template': getCookie('template'),
    'mantra': getCookie('mantraid'),
    'locale': getCookie('lang')
  });
});
